import {useState, useEffect} from "react";
import HeroPanel from "../components/home/hero-panel";
import AboutUs from "../components/home/about-us-panel";
import RoadmapPanel from "../components/home/roadmap-panel";
import JoinCommunityPanel from "../components/home/join-community-panel";
import {gPageView} from "../google-analytics";
import OGChefs from "../components/collections/og-chef-collection";

function HomePage() {
    const panels =  <div className="panel">
        <HeroPanel />
        <AboutUs />
        <RoadmapPanel />
        <OGChefs />
        <JoinCommunityPanel />
    </div>;
    useEffect(() => {
        gPageView('home');
    }, );
    return (
        <div id="hero-panel" >
            {panels}
        </div>
    );
}

export default HomePage;